<template>
    <div class="BusinessGeneralDetails">
        <div class="name_sector">
            <Card :title="$t('business.name-business')">
                <Picture name="new"/>
                <p v-text="business.name"
                />
            </Card>
            <Card :title="$t('business.sector')">
                <Picture name="budget"/>
                <p v-text="business.sector"
                />
            </Card>
            <Card :title="$t('business.total-investment')">
                <span class="investment">
                <p  v-text="business.totalInversion"
                />
                    <p class="dollar" v-text="'$'"/>
                </span>
            </Card>
        </div>
        <DataTable
                :data="business.advertisements"
                :headers="headers"
                @rowClick="navigateToItem"
                withPagination
        ><template slot-scope="{ row, header }">
            <TableField :data="row" :header="header"/>
        </template>
        </DataTable>
    </div>
</template>

<script>
  import { Picture, DataTable } from 'daas-components';
  import { Card } from '@/components';
  import { getBusinessDetail } from '@/api';
  import TableField from '@/components/DataTable/TableField';
  import Vuei18n from '@/translations';

  const headers = [
    {
      id: 'name',
      label: Vuei18n.t('dashboard.name'),
    },
    {
      id: 'investment',
      label: Vuei18n.t('dashboard.investment'),
    },
    {
      id: 'state',
      label: Vuei18n.t('dashboard.state'),
    },
  ];
  export default {
    name: 'BusinessGeneralDetails',
    data() {
      return {
        business: {},
        headers,
      };
    },
    components: {
      Card,
      Picture,
      DataTable,
      TableField,
    },
    methods: {
      navigateToItem(event,value) {
        const id = value.id;
        this.$router.push({
          name: 'advertisementDetail',
          params: {
            id,
            businessId: this.$route.params.id
          },
        });
      },
    },
    mounted() {
      getBusinessDetail(this.$route.params.id).then(
        data => {
          this.business = data
        },
        err => {
          console.log('Fetch Error: ', err);
        }
      );
    },
  };
</script>

<style lang="scss">
    .BusinessGeneralDetails {
        display: flex;
        justify-content: center;
        .name_sector {
            .Card {
                height: 30.6%;
                padding: rem(10) rem(40);
                margin-bottom: rem(20);
                p {
                    font-size: rem(25);
                }
                .investment{
                    display: flex;
                    align-items: center;
                    p{
                        font-size: rem(35);
                        margin: 0;
                    }
                    .dollar {
                        margin-left: rem(10);
                        font-size: rem(70);
                        color: $blue-400;
                        font-weight: 700;
                    }
                }
            }
        }
        .Picture {
            height: rem(70);
        }
        .DataTable {
            width: 35%;
            padding: rem(10);
            @include basicCard();
            margin-left: rem(20);
            &__Headers {
                margin-left: rem(10);
            }
        }
    }
</style>
